import React from "react";
import Table from "./table_race";
import Button from "../../components/subcomponents/controls/button";
import FormHeader from "../../components/subcomponents/formheader";
import { connect } from "react-redux";
import race_current from "../../api/race";
import race_history from "../../api/race_history";
import InputField from "../../components/subcomponents/controls/inputfield";
import SubformDetails from "../../components/subcomponents/subform_details";
import system from "../../api/system";

class eventDetailsFeed extends React.Component {
  constructor(props) {
    super(props);
    this.state = { banner_url: "", sponsors: [] };
  }
  componentWillMount() {
    race_current.event_details();
  }
  componentDidMount() {
    race_history.options();
    this.loadBranding();
  }
  loadBranding() {
    race_current.get_branding((branding) => {
      this.setState({
        banner_url: branding?.banner_url || "",
        sponsors: branding?.sponsors || [],
      });
    });
  }
  changeBanner(result) {
    this.setState({ banner_url: result.value });
  }
  changeSponsor(index, field, value) {
    const sponsors = this.state.sponsors.map((sponsor, i) =>
      i === index ? { ...sponsor, [field]: value } : sponsor
    );
    this.setState({ sponsors: sponsors });
  }
  addSponsor() {
    this.setState({
      sponsors: [
        ...this.state.sponsors,
        { name: "", image_url: "", link_url: "" },
      ],
    });
  }
  removeSponsor(result) {
    const index = result.params;
    this.setState({
      sponsors: this.state.sponsors.filter((sponsor, i) => i !== index),
    });
  }
  saveBranding() {
    race_current.save_branding(
      { banner_url: this.state.banner_url, sponsors: this.state.sponsors },
      (branding) => {
        // server strips invalid urls, so mirror what actually got stored
        this.setState({
          banner_url: branding?.banner_url || "",
          sponsors: branding?.sponsors || [],
        });
      }
    );
  }
  showImagePreview(url) {
    if (!url) return null;
    return (
      <img
        className="branding_preview"
        src={url}
        alt=""
        onError={(e) => (e.target.style.display = "none")}
        onLoad={(e) => (e.target.style.display = "")}
      />
    );
  }
  showSponsors() {
    return this.state.sponsors.map((sponsor, index) => (
      <div className="sponsor_row" key={index}>
        <InputField
          name="sponsor_name"
          postfix={index}
          label="Name"
          value={sponsor.name || ""}
          placeholder="Sponsor name"
          onChange={(r) => this.changeSponsor(index, "name", r.value)}
        />
        <InputField
          name="sponsor_image_url"
          postfix={index}
          label="Logo URL"
          value={sponsor.image_url || ""}
          placeholder="https://..."
          onChange={(r) => this.changeSponsor(index, "image_url", r.value)}
        />
        <InputField
          name="sponsor_link_url"
          postfix={index}
          label="Link URL"
          value={sponsor.link_url || ""}
          placeholder="https://... (optional)"
          onChange={(r) => this.changeSponsor(index, "link_url", r.value)}
        />
        {this.showImagePreview(sponsor.image_url)}
        <Button
          name="remove_sponsor"
          label="Remove"
          params={index}
          onClick={this.removeSponsor.bind(this)}
        />
      </div>
    ));
  }
  showBranding() {
    return (
      <SubformDetails
        title="Event branding"
        className="details branding width_100"
      >
        <InputField
          name="banner_url"
          label="Banner URL"
          value={this.state.banner_url}
          placeholder="https://..."
          onChange={this.changeBanner.bind(this)}
        />
        {this.showImagePreview(this.state.banner_url)}
        <div className="sponsor_list">{this.showSponsors()}</div>
        <div className="branding_toolbar">
          <Button
            name="add_sponsor"
            label="Add sponsor"
            onClick={this.addSponsor.bind(this)}
          />
          <Button
            name="save_branding"
            label="Save branding"
            onClick={this.saveBranding.bind(this)}
          />
        </div>
      </SubformDetails>
    );
  }
  showRaceDetails() {
    let race_title =
      "Race details for: " +
      this.props.race_details.cntrl_id +
      " drivers qty: " +
      this.props.race_competitors_list.length;
    return (
      <SubformDetails title={race_title} className="details width_100">
        <InputField
          name="company_name"
          label="Company"
          status="disabled"
          value={
            this.props.race_details_options.company_id.find(
              (company_id) =>
                company_id.value === this.props.race_details.company_id
            ).label
          }
        />

        <InputField
          name="name"
          label="Run"
          status="disabled"
          value={this.props.race_details.name}
        />
        <InputField
          name="track_name"
          label="Track name"
          status="disabled"
          value={this.props.race_details.track_name}
        />
        <InputField
          name="track_length"
          label="Length, km"
          status="disabled"
          value={this.props.race_details.track_length}
        />
        <InputField
          name="flag"
          label="Flag"
          status="disabled"
          value={this.props.race_details.flag}
        />
        <InputField
          name="laps"
          label="Laps to go"
          status="disabled"
          value={this.props.race_details.laps_to_go}
        />
        <InputField
          name="left_time"
          label="Time to go"
          status="disabled"
          value={this.props.race_details.left_time}
        />
        <InputField
          name="elapsed_time"
          label="Elapsed time"
          status="disabled"
          value={this.props.race_details.elapsed_time}
        />
        <InputField
          name="start_time"
          status="disabled"
          label="Started"
          onChange={this.props.fieldChange}
          value={this.props.race_details.start_time}
          input_control={{
            numericOnly: true,
            delimiters: [":"],
            blocks: [2, 2],
          }}
          placeholder="HH:mm"
        />
        <InputField
          status={"disabled"}
          name="race_type_id"
          label="Type"
          value={
            this.props.race_details_options["race_type_id"]?.find(
              (f) => f.value === this.props.race_details.race_type_id
            )?.label
          }
        />
        <InputField
          status={"disabled"}
          name="championship"
          label="Event"
          value={this.props.race_details.championship}
        />
      </SubformDetails>
    );
  }
  refresh() {
    race_current.event_details();
  }
  saveRace() {
    race_current.save_race();
  }
  setRaceType(obj) {
    race_current.set_race_type(obj.value);
  }
  setCompany(obj) {
    race_current.set_company(obj.value);
  }
  setChampionship(obj) {
    race_current.set_championship(obj.value);
  }
  sendState() {
    system.emit_system_event({
      event_name: "REQUEST_CONTROLLER_STATE",
      pl: { controller_mac: this.props.race_details.cntrl_id },
    });
  }

  showCompetitorsList() {
    let t_header = {
      position_by_time: { label: "Position", width: "3%" },
      nr: { label: "Nr", width: "3%" },
      firstname: { label: "F.name", width: "6%" },
      lastname: { label: "L.name", width: "6%" },
      orig_state: { label: "State", width: "3%" }, // show original state without converting
      orig_state2: { label: "State2", width: "3%" },
      class: { label: "Class", width: "6%" },
      club: { label: "Club", width: "6%" },
      sponsor: { label: "Sponsor", width: "6%" },
      make: { label: "Make", width: "6%" },
      model_engine: { label: "Model/Engine", width: "6%" },
      tires: { label: "Tires", width: "6%" },
      hometown: { label: "Hometown", width: "4%" },
      email: { label: "Email", width: "4%" },
      lap: { label: "Laps", width: "3%" },
      diff_by_lap: { label: "Diff", width: "4%" },
      gap_by_lap: { label: "Gap", width: "4%" },
      lap_time: { label: "LapTm", width: "4%" },
      best_lap_time: { label: "BestTm", width: "4%" },
      elapsed_time: { label: "TotalTm", width: "4%" },
      finished_time: { label: "FinishTm", width: "4%" },
    };

    return (
      <SubformDetails
        title="Competitors"
        className="details competitors width_100"
      >
        <div className="module_block_wrap">
          <Table
            name="events_details"
            table_key={"nr"}
            table_class="compact"
            headers={t_header}
            data={this.props.race_competitors_list}
          />
        </div>
      </SubformDetails>
    );
  }
  render() {
    return (
      <div className="form_wrap race_event_details">
        <FormHeader title="RACE FEED" />
        <div className="toolbar">
          <Button
            name="save"
            label="Save race"
            onClick={this.saveRace.bind(this)}
          />
          <Button
            name="send_state"
            label="Send state"
            onClick={this.sendState.bind(this)}
          />
        </div>
        {this.showRaceDetails()}
        {this.showBranding()}
        {this.showCompetitorsList()}
      </div>
    );
  }
}

function stateArr(obj = {}) {
  let state_arr = [];
  Object.keys(obj).forEach((field) => {
    state_arr.push(obj[field]);
  });
  return state_arr;
}

function mapStateToProps(state) {
  let race_details = state.raceR.race_details[state.raceR.events.selected];
  let history_events = state.raceR.history_events;
  let race_competitors =
    state.raceR.race_competitors[state.raceR.events.selected] || {};

  return {
    race_details: race_details || {},
    race_competitors_list: stateArr(race_competitors),
    sort_by_bl: state.raceR.sort_by_bl,
    sort_by_class: state.raceR.sort_by_class,
    refresh: state.raceR.refresh,
    race_details_options: history_events.options,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fieldChangeSort(result) {
      dispatch({
        type: "RACE_RESULT_SORT",
        field: result.name,
        value: result.value,
      });
    },
    fieldChange(result) {
      dispatch({
        type: "RACE_RESULT_SORT",
        field: result.name,
        value: result.value,
      });
    },
  };
}

export default eventDetailsFeed = connect(
  mapStateToProps,
  mapDispatchToProps
)(eventDetailsFeed);
